import { getFullUrl } from 'hubspot-url-utils';
import useNavItems from './useNavItems';
import { usePortal } from './useNavConfig';
const useHomePath = () => {
  const {
    portalId
  } = usePortal();
  const navItems = useNavItems();
  const home = navItems.byId['home'];
  return home ? home.path : `${getFullUrl('app')}/user-guide/${portalId}?via=home`;
};
export default useHomePath;